export default __webpack_public_path__ + "static/media/down-arrow.0789f4b6.svg";